/**
 * The fields of a catalog item a generator can honestly fill.
 *
 * **The DESCRIPTION is deliberately not among them.** It is an uncontrolled rich-text editor
 * after mount, so setting the state behind it would leave the value and the screen disagreeing
 * — which is the one thing the Autogenerate rule names as a field a generator may not write.
 * The reader types the one field only they can, and everything else the primary action is gated
 * on arrives filled.
 */
export function samplePpmpItem(): { unit: string; estimatedUnitCost: string } {
  const units = ['pc', 'box', 'lot', 'set', 'unit', 'ream'];

  return {
    unit: units[Math.floor(Math.random() * units.length)],
    // A plausible figure rather than a round one, so a reader can see the column is formatted.
    estimatedUnitCost: String(Math.floor(Math.random() * 40_000) / 4 + 125),
  };
}
